import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=774ff0b4&"
import script from "./member-list.vue?vue&type=script&lang=ts&"
export * from "./member-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports